export default "<nav class=\"sidebar\">\n  <app-sidebar-item *ngFor=\"let item of items\" [item]=\"item\"></app-sidebar-item>\n</nav>\n"